export default __webpack_public_path__ + "static/media/image.a1c6a3a5.svg";